var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "content-container",
    { staticClass: "party-form", attrs: { loading: _vm.loading } },
    [
      _c("ValidationObserver", {
        ref: "formObserver",
        attrs: { slim: "" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var handleSubmit = ref.handleSubmit
              return [
                _c(
                  "form",
                  {
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.onSubmit)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "list-container" }, [
                      _c(
                        "div",
                        { staticClass: "list-scroll" },
                        [
                          _vm._l(_vm.party, function(p, i) {
                            return _c(
                              "div",
                              {
                                key: "party-hard-" + i,
                                staticClass: "party-member"
                              },
                              [
                                _c("ValidationProvider", {
                                  attrs: {
                                    name: "Name",
                                    slim: "",
                                    rules: "required|clean|no-emoji|alpha-only",
                                    vid: "name-validation-" + i
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "div",
                                              [
                                                _c("error-container", {
                                                  attrs: { errors: errors }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "input-container"
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: p.name,
                                                          expression: "p.name"
                                                        }
                                                      ],
                                                      key: "name-input-" + i,
                                                      staticClass: "name-input",
                                                      attrs: {
                                                        type: "text",
                                                        placeholder: "Name"
                                                      },
                                                      domProps: {
                                                        value: p.name
                                                      },
                                                      on: {
                                                        keyup:
                                                          _vm.onTextChanged,
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            p,
                                                            "name",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                }),
                                _vm._v(" "),
                                _c("ValidationProvider", {
                                  attrs: {
                                    name: "House",
                                    slim: "",
                                    rules: "required",
                                    vid: "house-validation-" + i
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "div",
                                              [
                                                _c("error-container", {
                                                  attrs: { errors: errors }
                                                }),
                                                _vm._v(" "),
                                                _c("house-selector", {
                                                  key: "house-input-" + i,
                                                  model: {
                                                    value: p.house,
                                                    callback: function($$v) {
                                                      _vm.$set(p, "house", $$v)
                                                    },
                                                    expression: "p.house"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                }),
                                _vm._v(" "),
                                _c("separator")
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "filler" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "button-container add-button" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "add-btn",
                                  on: { click: _vm.addMember }
                                },
                                [_vm._v("Add Party Member")]
                              )
                            ]
                          )
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c("separator", { attrs: { big: "true", margin: "35px" } }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "button-container vertical form-buttons" },
                      [
                        _c(
                          "router-link",
                          { staticClass: "btn", attrs: { to: "/" } },
                          [_c("div", [_vm._v("Cancel")])]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "confirm-btn btn",
                            attrs: { type: "submit" }
                          },
                          [_vm._v("Submit")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }